// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projected-inventory-graph{position:relative;width:100%;min-height:12.5rem}", ""]);
// Exports
module.exports = exports;
